const twoDigitNumber = (num) => {
    // Accepts a number with decimals and rounds it to two digits
    return Number(num.toFixed(2));
}

export default twoDigitNumber;